import {
  trackContactClick,
  trackCtaClick,
  trackSocialClick,
} from "@/components/analytics/conversions";
import { useEffect } from "react";

function getContactMethod(href: string) {
  if (href.startsWith("mailto:")) return "email" as const;
  if (href.startsWith("tel:")) return "phone" as const;
  if (/wa\.me|whatsapp\.com/i.test(href)) return "whatsapp" as const;
  return null;
}

function getSocialPlatform(href: string) {
  if (/instagram\.com/i.test(href)) return "instagram";
  if (/youtube\.com|youtu\.be/i.test(href)) return "youtube";
  if (/facebook\.com/i.test(href)) return "facebook";
  if (/tiktok\.com/i.test(href)) return "tiktok";
  return null;
}

export function AnalyticsClickTracker() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (window.location.pathname.startsWith("/admin")) return;
      if (!(event.target instanceof Element)) return;
      const trackedElement = event.target.closest<HTMLElement>(
        "[data-analytics-cta], a[href]",
      );
      if (!trackedElement) return;

      const link = trackedElement.closest<HTMLAnchorElement>("a[href]");
      const href = link?.href || "";
      const safeDestination = link
        ? `${link.origin}${link.pathname}`
        : undefined;
      const ctaName = trackedElement.dataset.analyticsCta;
      if (ctaName) {
        trackCtaClick(ctaName, safeDestination);
        return;
      }

      const contactMethod = getContactMethod(href);
      if (contactMethod) {
        trackContactClick(contactMethod);
        return;
      }

      const socialPlatform = getSocialPlatform(href);
      if (socialPlatform && safeDestination) {
        trackSocialClick(socialPlatform, safeDestination);
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
}
